/**
 * Returns the plan variant for the given plan name for amplitude events
 * to match the OnboardingVariant property.
 */
export const getOnboardingVariant = (
  planName: string | undefined,
): 'Serverless' | 'GraphOS-Trial' | 'Enterprise-Trial' | 'Free' | 'Other' => {
  if (!planName || planName === 'Free') return 'Free';

  if (planName.includes('Enterprise')) return 'Enterprise-Trial';
  if (planName.includes('GraphOS')) return 'GraphOS-Trial';
  if (planName.includes('Serverless')) return 'Serverless';

  return 'Other';
};
